<template>
  <div class="wrap">
    <div class="top">
      <div class="font-bigger">登录</div>
      <div class="font-intro">欢迎您回来~</div>
    </div>
    <!-- <van-sticky>
      <van-nav-bar :safe-area-inset-top="true" title="登录" />
    </van-sticky>
    <div class="slogan flex-row-center">经验，成就人生</div> -->
    <!-- 登录框 -->
    <div class="block">
      <van-form v-if="loginMethod === 'tel'" @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="formData.tel"
            name="tel"
            label="手机号"
            type="number"
            placeholder="请输入手机号"
            :rules="[{ required: true, message: '请填写手机号' }]"
          />
          <van-field
            v-model="formData.code"
            type="number"
            name="code"
            label="验证码"
            autocomplete="one-time-code"
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          >
            <template #button>
              <van-button @click="sendCodeClick" :disabled="codeTime > 0" size="small" type="primary" color="#ff9e19">{{ codeTime > 0 ? '重新发送（'+ codeTime +'）' : '发送验证码' }}</van-button>
            </template>
          </van-field>
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit" color="#ff9e19">
            立即登录
          </van-button>
        </div>
      </van-form>
      <div v-if="loginMethod === 'wechat'" style="margin: 16px;">
        <van-button round block color="#ff9e19" @click="wechatLogin">
          微信授权登录
        </van-button>
      </div>
    </div>
    <div class="bottom">
      <div class="wechat">
        <van-icon name="phone" size="32" :color="loginMethod === 'tel' ? '#1AAD19' : '#A7A7A7'" @click="loginMethod = 'tel'" style="margin: 10px;"/>
        <!-- <van-icon name="chat" size="32" :color="loginMethod === 'wechat' ? '#1AAD19' : '#A7A7A7'" @click="loginMethod = 'wechat'" style="margin: 10px;" /> -->
      </div>
      <div>北京康萍科技有限公司 京ICP备17029900号-1</div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { login, sendCode, wechatAuth } from '../../../api/login'
export default {
  data() {
    return {
      loginMethod: 'tel',
      companyId: '',
      adminId: '',
      inviterId: '',
      isWorker: '',
      timer: null,
      codeTime: 0,
      formData: {
        tel: '',
        code: ''
      }
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    wechatLogin() {
      wechatAuth('login').then(res => {
        window.location.href = res
      })
    },
    timerFunction() {
      this.codeTime--
      if (this.codeTime <= 0) {
        clearInterval(this.timer)
      }
    },
    sendCodeClick() {
      // 发送验证码
      if (!this.formData.tel) {
        Toast('请输入手机号')
        return false
      }
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formData.tel))) {
        Toast('手机号格式有误')
        return false
      }
      // 发送
      sendCode(this.formData.tel).then(() => {
        Toast('验证码发送成功')
        this.codeTime = 300
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.timerFunction()
        }, 1000)
      })
    },
    onSubmit() {
      // 登录
      login({
        ...this.formData,
        adminId: this.adminId,
        isWorker: this.isWorker,
        inviterId: this.inviterId,
        companyId: this.companyId
      }).then(res => {
        Toast('登录成功')
        localStorage.setItem('reload', true)
        localStorage.setItem('Token', res.token)
        localStorage.setItem('UserId', res.userId)
        localStorage.setItem('Tel', this.formData.tel)
        localStorage.setItem('TokenLogin', false)
        // 跳转
        setTimeout(() => {
          const cachePage = localStorage.getItem('CachePage')
          if (cachePage) {
            localStorage.setItem('CachePage', '')
            location.href = cachePage
          } else if (localStorage.getItem('welcome-url')) {
            location.href = localStorage.getItem('welcome-url')
          } else {
            this.$router.push({
              path: '/mine'
            })
          }
        }, 1000)
      })
    },
    init() {
      // this.$route.query.searchValue
      if (this.$route.query.companyId && this.$route.query.companyId != localStorage.getItem('CompanyId')) {
        localStorage.setItem('CompanyId', this.$route.query.companyId)
        window.location.reload()
      }
      if (this.$route.query.companyId) {
        this.companyId = this.$route.query.companyId
      }
      if (this.$route.query.adminId) {
        this.adminId = this.$route.query.adminId
      }
      if (this.$route.query.inviterId) {
        this.inviterId = this.$route.query.inviterId
      }
      if (this.$route.query.isWorker) {
        this.isWorker = this.$route.query.isWorker
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
body {
  background: #fff!important;
}
.wrap {
  height: 100%;
  width: 100%;
  position: fixed;
  background: #fff;
}
.top {
  background: url('../../../assets/images/bg.png');
  background-size: cover;
  height: 480px;
  padding-left: 96px;
  .font-bigger {
    padding-top: 80px;
    font-size: .84rem;
  }
  .font-intro {
    padding-top: 8px;
    font-size: .32rem;
  }
}
.block {
  margin: 0 40px;
  margin-top: 120px;
}
.van-cell-group {
  background: #f3f3f3!important;
}
.van-cell {
  background: #f3f3f3!important;
}
.bottom {
  position: fixed;
  bottom: 40px;
  width: 100%;
  text-align: center;
  font-size: .32rem;
  color: #999999;
  div {
    margin-bottom: 8px;
  }
}
.wechat {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>